import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const RecurranceIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M17.0399 5.28004H19.8399V3.04004H14.2399C13.6209 3.04004 13.1199 3.54099 13.1199 4.16004V9.76004H15.3599V6.84188C16.7413 7.74424 17.7038 9.16283 18.0309 10.7804C18.3568 12.398 18.021 14.079 17.0979 15.4463C16.1759 16.8146 14.742 17.7541 13.12 18.056V20.3244C15.3359 20.0258 17.3407 18.8566 18.6914 17.0759C20.0433 15.2941 20.6285 13.0486 20.3178 10.8338C20.0083 8.62008 18.8282 6.62208 17.0399 5.28004Z'
                fill='currentColor'
            />
            <Path
                d='M8.63993 17.1583C7.25853 16.256 6.29603 14.8374 5.96899 13.2198C5.64304 11.6022 5.97883 9.92115 6.90195 8.55391C7.82399 7.18564 9.25789 6.2461 10.8799 5.94423V3.67578C8.66396 3.97437 6.65919 5.1436 5.30847 6.92434C3.9566 8.70606 3.37143 10.9516 3.68206 13.1664C3.9916 15.3801 5.17174 17.3784 6.96002 18.7205H4.16002V20.9605H9.76002C10.0575 20.9605 10.3419 20.8423 10.5519 20.6323C10.7619 20.4223 10.88 20.138 10.88 19.8405V14.2405H8.64002L8.63993 17.1583Z'
                fill='currentColor'
            />
        </>
    ),
})

RecurranceIcon.displayName = 'RecurranceIcon'
